import React from "react";
import { Route } from "react-router-dom";
import Login from "../../DemoPages/User/Login";

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem("auth") ? (
          <Component {...props} />
        ) : (
          <Login />
        )
      }
    />
  );
};

export default PrivateRoute;
